import React, { useState } from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { useFormattedInput } from "./paymentCardNumber";
import { digitsOnly, formatExpiryInput, normalizeExpiry } from "../../../../helpers/paymentCard";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }
  return classes.join(" ");
};

/** Expiry input, kept as "MM/YY" in form state. Always left-to-right, also in the Arabic interface. */
export function PaymentCardExpiry({
  field,
  label,
  classes,
  customFeedbackLabel,
  form: { touched, errors, setFieldValue },
  withFeedbackLabel = true,
  ...props
}) {
  const [focused, setFocused] = useState(false);
  const { inputRef, setValueAndCaret } = useFormattedInput();

  const handleChange = (e) => {
    const input = e.target;
    const raw = input.value;
    const caret = input.selectionStart == null ? raw.length : input.selectionStart;
    const value = formatExpiryInput(raw, { deleting: raw.length < (field.value || "").length });

    setValueAndCaret(input, value, digitsOnly(raw.slice(0, caret)).length, caret === raw.length);
    setFieldValue(field.name, value);
  };

  // No error while the user is still typing the date, only once it is complete or the field is left
  const showError = touched[field.name] && !(focused && !normalizeExpiry(field.value));

  return (
    <>
      <input
        {...props}
        ref={inputRef}
        type="text"
        inputMode="numeric"
        autoComplete="cc-exp"
        dir="ltr"
        className={`${classes} ${getFieldCSSClasses(showError, errors[field.name])} payment-card-ltr-input`}
        name={field.name}
        value={field.value}
        onFocus={() => setFocused(true)}
        onBlur={(e) => {
          setFocused(false);
          field.onBlur(e);
        }}
        onChange={handleChange}
      />
      {label && <label>{label}</label>}
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          type="text"
          label={label}
          error={errors[field.name]}
          touched={showError}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
